'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _priceString = require('helpers/priceString');

var _priceString2 = _interopRequireDefault(_priceString);

var _PricePer = require('./PricePer.jsx');

var _PricePer2 = _interopRequireDefault(_PricePer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TicketDetails(props) {
  var components = props.components,
      perPassenger = props.perPassenger,
      total = props.total,
      selectedCurrencyFormat = props.selectedCurrencyFormat;


  var styleTicketApproximatePtcValue = {
    color: components.TicketApproximatePtcValue.color,
    fontSize: components.TicketApproximatePtcValue.fontSize,
    fontWeight: components.TicketApproximatePtcValue.fontWeight,
    fontStyle: components.TicketApproximatePtcValue.fontStyle,
    textDecoration: components.TicketApproximatePtcValue.textDecoration,
    fontFamily: components.TicketApproximatePtcValue.fontFamily
  };

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'TotalSplit' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { verticalAlign: 'top', padding: '0', width: '70%' } },
          _react2.default.createElement(_PricePer2.default, { ptcs: perPassenger })
        ),
        _react2.default.createElement(
          'td',
          { style: { verticalAlign: 'top', padding: '0', textAlign: 'left', width: '30%' } },
          _react2.default.createElement(
            'span',
            { style: styleTicketApproximatePtcValue },
            (0, _priceString2.default)(selectedCurrencyFormat, total.priceData.totalPrice + total.priceData.markupAmount + total.priceData.feeAmount + total.priceData.obFeeAmount || 0, total.priceData.currency)
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  var basketCurrencyFormat = state.rendering.shopOptions.currencyFormat;
  return {
    components: state.templateApplication.templates.currentTemplate.components,
    selectedCurrencyFormat: basketCurrencyFormat || state.templateApplication.templates.currentTemplate.currencyFormat
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(TicketDetails);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/TicketDetails.jsx
// module id = 1485
// module chunks = 0